import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Information from 'views/usersVerification/information'; // Importing Information view
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * UsersVerificationView class extends JetView to create a user verification interface.
 */
export default class UsersVerificationView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        var vthis = this; // Reference to the current instance

        const left = {
            css: 'int-left', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying theme to the toolbar
                    elements: [
                        {
                            view: 'label', // Label element in the toolbar
                            align: 'center', // Center alignment
                            label: _('Aprobación de Usuarios'), // Localized label text
                        },
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the button
                            cols: [
                                {
                                    view: 'icon', // Icon button for search
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        // Click event handler
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon button for close
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Information, // Including Information view
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Vertical scrolling enabled
            css: 'scrolling', // CSS class for scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide', // Wide type for the column
                    cols: [left], // Left column containing the toolbar and information
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        webix.ready(function () {
            // Ensures the DOM is ready before executing
            webix.attachEvent('onRotate', function (orientation) {
                // Event listener for screen rotation
                window.location.reload(); // Reload the page on orientation change
            });
            if (screen.width > 500 && screen.height > 500) {
                // Check screen dimensions
                $$('button-search').hide(); // Hide search button on larger screens
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $$(document).height() - this.scrollTop() - this.height(); // Return scroll bottom value
            };
        });
    }
}

// FILE DOCUMENTED
